import React, { useEffect, useState } from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
  CustomInput,
} from "../../../../components";

import "./index.sass";
import convertNumberToPrice from "../../../../utils/convertNumberToPrice";
import { useTranslation } from "react-i18next";

const Deposit = () => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedDriver,
    depositFunction,
  } = React.useContext(Context.DriverScreen);

  const [price, setPrice] = useState<number>(
    selectedDriver?.schoolDriverInformation?.deposit
  );

  useEffect(() => {
    setPrice(selectedDriver?.schoolDriverInformation?.deposit);
  }, [selectedDriver]);

  const { t } = useTranslation();

  // console.log(selectedDriver);

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DRIVER_DEPOSIT"}
        label=""
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <CustomInput
                name="price"
                id="price"
                label={t("price")}
                value={price?.toString()}
                // value={convertNumberToPrice(totalPrice as number) + " تومان"}

                onValueChange={(event) => setPrice(Number(event.target.value))}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() =>
                  depositFunction!({
                    driverId: selectedDriver?._id,
                    price: price,
                  })
                }
                title={t("update")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Deposit;
